<template>
  <div>
    <span class="null-user-entity-activities">
      <h5>{{$t('entities.activities.without_user')}}&nbsp;&nbsp;
        <a v-if="availableActivities.length && !editingNullActivities" href="#" @click.prevent="editingNullActivities = true">
          <i class="fa fa-pencil"></i>
        </a>
      </h5>
      <span v-if="!availableActivities.length">
        <small>{{ $t('entities.activities.no_entity_activity_provider') }}<br> {{ $t('entities.activities.configure_entity_activity_provider') }}</small>
      </span>
      <va-checkbox
        v-for="activity in availableActivities"
        :key="activity.id"
        :label="$t(`evocall.activities.${activity.id}`, activity.name)"
        :id="`${activity.id}`"
        :isCircle="true"
        v-model="activity.available"
        :disabled="!editingNullActivities"/>
      <div class="row" v-if="editingNullActivities">
        <va-button
          small
          class="btn-cancel"
          @click.prevent="cancel">
          {{$t('modals.buttons.cancel')}}
        </va-button>
        <va-button
          small
          @click.prevent="save">
          {{$t('modals.buttons.save')}}
        </va-button>
      </div>
    </span>
  </div>
  
</template>
<script>
import { uniqBy, flatten } from 'lodash'
import { EntityActivityUserService } from '@/api/AuthService'

export default {
  props: {
    entity: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      editingNullActivities: false,
      availableActivities: [],
      nullUserActivities: []
    }
  },
  methods: {
    loadNullUserActivities: function (url = `${this.$store.state.evollauth_server}/entities-activities-users`) {
      this.$http({
        url: url,
        params: { infoType: 140, entities: this.entity.id, nullUser: true }
      }).then((response) => {
        this.nullUserActivities = response.data.data
        this.loadEntityAvailableActivities()
      }).catch((err) => {
        console.error(err)
      })
    },
    loadEntityAvailableActivities: function (url = `${this.$store.state.evollauth_server}/entities/${this.entity.id}/workactivities`) {
      this.$http({ url })
        .then(response => {
          let activities = response.data.data
          this.availableActivities = uniqBy(flatten(activities.filter(item => {
            return item.entity.id === this.entity.id
          }).map(item => {
            return {
              id: item.activity.id,
              name: item.activity.name,
              available: this.nullUserActivities.findIndex(nullactivity => nullactivity.activity.id === item.activity.id) !== -1
            }
          })), 'id')
          this.$emit('available-ativities-loaded', this.availableActivities)
        })
        .catch(err => console.log(err))
    },
    cancel: function () {
      this.editingNullActivities = false
    },
    save: function () {
      let nullUserActivitiesToCreate = this.availableActivities
        .filter(activity => activity.available)
        .filter(activity => {
          return !this.nullUserActivities.some(nullActivity => nullActivity.activity.id === activity.id)
        })

      let promises = nullUserActivitiesToCreate.map((activity) => this.createNullUserActivity(activity.id))

      let nullUserActivitiesToDelete = this.nullUserActivities.filter(nullActivity => {
        return this.availableActivities.filter(activity => !activity.available).some(activity => activity.id === nullActivity.activity.id)
      })

      promises.concat(nullUserActivitiesToDelete.map((activity) => this.deleteNullUserActivity(activity.id)))

      Promise.all(promises)
        .then((data) => {
          this.showToast(this.$t('entities.activities.multiple_edited'), this.$store.state.successToastOptions)
        }).catch((err) => {
          console.log(err)
          this.showToast(this.$t('entities.activities.multiple_edit_error'), this.$store.state.errorToastOptions)
        }).finally(() => {
          this.loadNullUserActivities()
          this.editingNullActivities = false
        })
    },
    createNullUserActivity: function (activityId) {
      return new Promise((resolve, reject) => {
        EntityActivityUserService.store({
          entity_id: this.entity.id,
          activity_id: activityId,
          user_id: null,
          start_date: null,
          end_date: null
        }).then(entityActivityUser => {
          resolve(entityActivityUser)
        }).catch(errors => {
          console.log(errors)
        })
      })
    },
    deleteNullUserActivity: function (activityId) {
      return new Promise((resolve, reject) => {
        EntityActivityUserService.delete(activityId)
          .then((response) => {
            resolve(response.data.data)
          }).catch((err) => {
            reject(err)
          })
      })
    },
  },
  watch: {
    entity: {
      handler () {
        this.loadNullUserActivities()
      },
      immediate: true,
      deep: true
    },
  }
}
</script>
